import { Identifier } from 'types/utilityTypes';

export interface Webhook {
  id: Identifier;
  description: string;
  secret: string;
  createdAt: Date;
  eventTypes: string[];
  url: string;
}

export const webhookEvents = [
  { id: 'client_created', name: 'Client Created' },
  { id: 'visit_booked', name: 'Visit Booked' },
  { id: 'visit_completed', name: 'Visit Completed' },
  { id: 'measurement_logged', name: 'Measurement Logged' },
  { id: 'user_created', name: 'Account Created' },
  { id: 'user_updated', name: 'Account Updated' },
  { id: 'message_received', name: 'Message Received' },
  { id: 'message_sent', name: 'Message Sent' },
];
